// Copyright (c) 2016 Deere & Company

import './new-transfer.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerPanel from '../../../shared/components/customer-panel/customer-panel';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Modal from '../../shared/state/modal';
import NewTransferBody from './new-transfer-body';
import NewTransferHeader from './new-transfer-header';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import Transfer from '@deere/cps-it.warranty-model-factory/lib/transfer';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {isCommentValid} from '../validations/comment-validation';

function handleCancelClick() {

    this.actions.goToPreviousView();

}

function handleCreateTransferClick() {

    this.actions.createTransfer();

}

function handleGoToDealerSearchClick() {

    this.actions.updateDealerSearchModalVisibility(this.dealerSearchModal.isVisible);

}

function handleAccountLookupChange(account) {

    this.actions.updateAccountLookup(account);

}

function handleAccountLookupBlur(account) {

    this.actions.readDealer(account);

}

function handleReasonForTransferInputChange(event) {

    if (isCommentValid(this.newTransfer.reasonForChange, event.target.value)) {

        this.actions.updateReasonForChange(event.target.value);

    }

}

function handleResetTransferClick() {

    this.actions.resetNewTransfer();

}

function handleStatusChangeModalVisibility(value) {

    this.actions.updateNewTransferStatusChangeModal('isVisible', value);

}

function handleAmountOfUseModalClose() {

    this.actions.updateAmountOfUseModalVisibility(false);

}

function handleAmountOfUseModalOpen() {

    this.actions.updateAmountOfUseModalVisibility(true);

}

function handleUpdateStatus() {

    this.actions.updateNewTransferStatusChangeModal('isVisible', false);
    this.actions.goToStatusChangeRequestView(this.product.pin);

}

class NewTransfer extends Component {

    componentWillMount() {

        this.props.actions.resetAccountLookup();
        this.props.actions.resetNewTransfer();
        this.props.actions.updateProduct(this.props.routeParams.pin);

    }

    componentWillUnmount() {

        this.props.actions.resetProductDetails();
        this.props.actions.resetCustomerDetails();
        this.props.actions.resetCkcCustomerFailure();
        this.props.actions.resetLatestPerUnitMeasurements();
        this.props.actions.updateAmountOfUseModalVisibility(false);

    }

    render() {

        return (
            <section className='new-transfer'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <main>
                    <NewTransferHeader
                        changeModalVisibility={this.props::handleStatusChangeModalVisibility}
                        isAmountOfUseModalOpen={this.props.isAmountOfUseModalOpen}
                        measurementReadings={this.props.measurementReadings}
                        onAmountOfUseModalClose={this.props::handleAmountOfUseModalClose}
                        onAmountOfUseModalOpen={this.props::handleAmountOfUseModalOpen}
                        product={this.props.product}
                        productStatusChangeModal={this.props.newTransferStatusChangeModal}
                        updateStatus={this.props::handleUpdateStatus}
                    />
                    <NewTransferBody
                        accountLookup={this.props.accountLookup}
                        dealer={this.props.product.dealer}
                        dealerSearchModal={this.props.dealerSearchModal}
                        newTransfer={this.props.newTransfer}
                        onAccountLookupBlur={this.props::handleAccountLookupBlur}
                        onAccountLookupChange={this.props::handleAccountLookupChange}
                        onCancelClick={this.props::handleCancelClick}
                        onCreateTransferClick={this.props::handleCreateTransferClick}
                        onDealerSearchViewClick={this.props::handleGoToDealerSearchClick}
                        onReasonForChangeInputChange={this.props::handleReasonForTransferInputChange}
                        onResetClick={this.props:: handleResetTransferClick}
                    />
                </main>
                <aside>
                    <CustomerPanel
                        customer={this.props.customer}
                        isCkcCustomerFailed={this.props.isCkcCustomerFailed}
                        product={this.props.product}
                    />
                </aside>
            </section>
        );

    }

}

NewTransfer.displayName = 'NewTransfer';
NewTransfer.propTypes = {
    accountLookup: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal).isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    isCkcCustomerFailed: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    newTransfer: PropTypes.instanceOf(Transfer).isRequired,
    newTransferStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    routeParams: PropTypes.object.isRequired
};

export default NewTransfer;



// WEBPACK FOOTER //
// ./src/product/new-transfer/components/new-transfer.js